import { GridRenderCellParams } from '@mui/x-data-grid'

import { FplDataGrid, IGridColumn } from 'components/common/FplDataGrid/FplDataGrid'
import {
  WecAiBookingNotAcceptedSchedulerFeatureName,
  WecAiMissingPocPodSchedulerFeatureName,
  WecAiCollectionDeliveryDelaySchedulerFeatureName,
  WecAiDriverOnboardingSchedulerFeatureName,
  WecAiETAProviderSchedulerFeatureName,
} from 'constants/EntityConstants/AppFeature'
import { GET_WEC_AI_SCHEDULERS_APP_FEATURES } from 'graphql/queries/AppFeatureQueries'

import WecAiSchedulerStateSwitch from './WecAiSchedulerStateSwitch'

const SchedulerNameFormatter = (name: string) => {
  switch (name) {
    case WecAiBookingNotAcceptedSchedulerFeatureName:
      return 'Booking Not Accepted Reminder'
    case WecAiMissingPocPodSchedulerFeatureName:
      return 'Missing POC/POD Reminder'
    case WecAiCollectionDeliveryDelaySchedulerFeatureName:
      return 'Collection/Delivery Delay Reminder'
    case WecAiDriverOnboardingSchedulerFeatureName:
      return 'Driver Onboarding Reminder'
    case WecAiETAProviderSchedulerFeatureName:
      return 'ETA Provider Reminder'
    default:
      return name
  }
}

const WecAiSchedulersFlags = () => {
  const columns: IGridColumn[] = [
    {
      field: 'action',
      headerName: '',
      width: 80,
      sortable: false,
      filterable: false,
      disableColumnMenu: true,
      renderCell: ({ row }: GridRenderCellParams) => (
        <WecAiSchedulerStateSwitch name={row.name} state={row.state} />
      ),
    },
    {
      field: 'name',
      headerName: 'Scheduler Name',
      minWidth: 250,
      flex: 1,
      sortable: false,
      valueFormatter: ({ value }) => SchedulerNameFormatter(value),
    },
    {
      field: 'state',
      headerName: 'State',
      minWidth: 100,
      flex: 1,
      sortable: false,
      valueFormatter: ({ value }) => (value ? 'ON' : 'OFF'),
    },
    {
      field: 'lastModifiedAt',
      headerName: 'Last Updated',
      minWidth: 150,
      flex: 1,
      sortable: false,
      valueFormatter: ({ value }) => value === null ? 'N/A' : new Date(value).toLocaleString() ?? 'N/A',
    },
    {
      field: 'lastModifiedBy',
      headerName: 'Last Updated By',
      minWidth: 150,
      flex: 1,
      type: 'string',
      sortable: false,
      valueFormatter: ({ value }) => value ?? 'N/A',
    },
  ]

  return (
    <FplDataGrid
      query={GET_WEC_AI_SCHEDULERS_APP_FEATURES}
      entityName='wecAiAppFeatures'
      columns={columns}
      defaultOrder={{ field: 'name', sort: 'asc' }}
      toolbar={{
        caption: 'WecAi Schedulers',
      }}
      disableSelectionOnClick
    />
  )
}

export default WecAiSchedulersFlags
